import React, { useEffect, useState, Fragment } from 'react';
import { isMonthAndYearEmpty, isNumeric, getStatusFlagValue, getButtonDisabledStates } from '../Custom/Custom'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import messages from '../assets/Messages.json'
import axios from "axios";
import { API_URL } from '../Constant';
import { showLoading } from 'react-global-loading';


function RuralMenWagesData({
  ruralMenWagesRates,
  blockAllData,
  yearName,
  monthName,
  userInfoObject,
  config,
  districtCode,
  resetMothAndYearAndDistrictField,
  ruralMenEmptyObject,
  averageData,
  monthAndYearValidation,
  payload,
  storedLanguage,
  priceTitle,
  titlesData
}) {



  const [itemData, setItemData] = useState({});
  const [checkedItems, setCheckedItems] = useState([]);
  const navigate = useNavigate();
  let srNo = 0;
  const {
    isSaveBtnDisable,
    isSubmitBtnDisable,
    isAcceptBtnDisable,
    isRejectBtnDisable
  } = getButtonDisabledStates(payload, userInfoObject);

  let headQuarterRemark = [
    'Wages is Too Low.',
    'Wages is too High.',
    'Worng entry'
  ]
  let otherRemark = [
    'High demand of laboures.',
    'Low demand of laboures.',
    'Entry is correct.',
    'Enter has been amended.',
  ]

  const ruralMenPropertyNames = [
    "carpenterTotalWagesAvg",
    "masonTotalWagesAvg",
    "tailorTotalWagesAvg",
    "barberTotalWagesAvg",
    "spillerCrusherWagesAvg",
    "spillerMachineWagesAvg",
    "bricksAvg",
    "cowTotalWagesAvg",
    "buffaloTotalWagesAvg",
    "ploughingTotalWagesAvg",
    "showingTotalWagesAvg",
    "weedingTotalWagesAvg",
    "harvestingTotalWagesAvg",
    "threshingTotalWagesAvg",
    "otherTotalWages",
    "blockCode",
    "locationCode",
    "carpenterTotalWages",
    "masonTotalWages",
    "tailorTotalWages",
    "barberTotalWages",
    "spillerMachineWages",
    "spillerCrusherWages",
    "bricksTotalWages",
    "charwahaCowTotalWages",
    "charwahaBuffaloTotalWages",
    "ploughingTotalWages",
    "sowingTotalWages",
    "weedingTotalWages",
    "harvestingTotalWages",
    "threshingTotalWages",
    "totalDevlopArea",
    "statusFlag",
    "locationName",
    "blockName",
    "remarkCarpenterTotalWages",
    "remarkMasonTotalWages",
    "remarkTailorTotalWages",
    "remarkBarberTotalWages",
    "remarkSpillerMachineWages",
    "remarkSpillerCrusherWages",
    "remarkBricks",
    "remarkCowTotalWages",
    "remarkBuffaloTotalWages",
    "remarkPloughingTotalWages",
    "remarkShowingTotalWages",
    "remarkWeedingTotalWages",
    "remarkHarvestingTotalWages",
    "remarkThreshingTotalWages",
    "remarkOtherTotalWages",
    "source",
    "rejectRemark",
    "remarkCarpenterTotalWagesSelectValue",
    "remarkMasonTotalWagesSelectValue",
    "remarkTailorTotalWagesSelectValue",
    "remarkBarberTotalWagesSelectValue",
    "remarkSpillerMachineWagesSelectValue",
    "remarkSpillerCrusherWagesSelectValue",
    "remarkBricksSelectValue",
    "remarkCowTotalWagesSelectValue",
    "remarkBuffaloTotalWagesSelectValue",
    "remarkPloughingTotalWagesSelectValue",
    "remarkShowingTotalWagesSelectValue",
    "remarkWeedingTotalWagesSelectValue",
    "remarkHarvestingTotalWagesSelectValue",
    "remarkThreshingTotalWagesSelectValue",
    "remarkOtherTotalWagesSelectValue",
    "carpenterTotalWagesStyle",
    "masonTotalWagesStyle",
    "tailorTotalWagesStyle",
    "barberTotalWagesStyle",
    "spillerMachineWagesStyle",
    "spillerCrusherWagesStyle",
    "bricksTotalWagesStyle",
    "charwahaCowTotalWagesStyle",
    "charwahaBuffaloTotalWagesStyle",
    "ploughingTotalWagesStyle",
    "sowingTotalWagesStyle",
    "weedingTotalWagesStyle",
    "harvestingTotalWagesStyle",
    "threshingTotalWagesStyle",
    "otherTotalWagesStyle",
    "carpenterTotalWagesIsRequiredRemark",
    "masonTotalWagesIsRequiredRemark",
    "tailorTotalWagesIsRequiredRemark",
    "barberTotalWagesIsRequiredRemark",
    "spillerMachineWagesIsRequiredRemark",
    "spillerCrusherWagesIsRequiredRemark",
    "bricksTotalWagesIsRequiredRemark",
    "charwahaCowTotalWagesIsRequiredRemark",
    "charwahaBuffaloTotalWagesIsRequiredRemark",
    "ploughingTotalWagesIsRequiredRemark",
    "sowingTotalWagesIsRequiredRemark",
    "weedingTotalWagesIsRequiredRemark",
    "harvestingTotalWagesIsRequiredRemark",
    "threshingTotalWagesIsRequiredRemark",
    "otherTotalWagesIsRequiredRemark"

  ];





  useEffect(() => {
    let ruralMenWagesData = ruralMenWagesRates;
    customObjectObjectData(ruralMenWagesData)
  }, [ruralMenWagesRates])


  const customObjectObjectData = (ruralMenWagesData) => {
    const initialData = {};
    ruralMenWagesData.forEach((item, i) => {
      initialData[i] = { id: i };
      ruralMenPropertyNames.forEach(property => {
        initialData[i][property] = item?.[property] ?? '';
      });
    });
    setItemData(initialData);
  }


  // handle the add row on add row button  click
  const addRow = () => {
    let newCustomObject = [];
    for (let i = 0; i < 1; i++) {
      const newItemAdded = {
        id: i,
        ...ruralMenEmptyObject
      };
      newCustomObject.push(newItemAdded);
    }
    const dataArray = Object.values(itemData);
    const AddedIndex = dataArray.length
    dataArray.splice(AddedIndex, 0, ...newCustomObject);
    customObjectObjectData(dataArray)
  };

  //handle delete row
  const deleteRows = () => {
    const dataArray = Object.values(itemData);
    if (checkedItems.length === 0) {
      toast.error(`Please check the checkbox`, messages.COLOR_RED);
      return false;
    }
    if (dataArray.length > 1) {
      const updatedItems = dataArray.filter((_, index) => !checkedItems.includes(index));
      customObjectObjectData(updatedItems)
      setCheckedItems([]);
    } else {
      toast.error('Row cannot be deleted', messages.COLOR_RED);
    }

  };



  const remarkDropDown = (item, i, selectedValueKey, forRemarkTextKey, requiredKey = '') => {
    let headQuarterSelected = '';
    let otherSelected = '';

    if (headQuarterRemark.includes(item[forRemarkTextKey])) {
      headQuarterSelected = item[forRemarkTextKey]
    }
    if (otherRemark.includes(item[forRemarkTextKey])) {
      otherSelected = item[forRemarkTextKey]
    }

    return (
      <>
        {/* {  item[forRemarkTextKey] && (
          <label className="text-danger danger_msg_fontSize">{ item[forRemarkTextKey]}</label>
        )} */}

        {/* Show remark Text */}
        {
          (userInfoObject.userLevel !== 'HEAD QUARTER') &&
          (!otherRemark.includes(item[forRemarkTextKey])) && item[forRemarkTextKey] &&
          <label className="text-danger danger_msg_fontSize">{item[forRemarkTextKey]}</label>
        }

        {
          (userInfoObject.userLevel === 'HEAD QUARTER') &&
          (!headQuarterRemark.includes(item[forRemarkTextKey])) && item[forRemarkTextKey] &&
          <label className="text-danger danger_msg_fontSize">{item[forRemarkTextKey]}</label>
        }

        {userInfoObject.userLevel === 'HEAD QUARTER' ?
          <select
            key={`thead-${i}`}
            className="form-select"
            name={`${selectedValueKey}${i}`}
            id={`${selectedValueKey}${i}`}
            value={headQuarterSelected ? headQuarterSelected : item[selectedValueKey]}
            onChange={e => handleOnChangeRemark(item, selectedValueKey, forRemarkTextKey, e.target.value, requiredKey)}
          >
            <option value="">Select</option>
            {headQuarterRemark.map((remarkItem, i) => {
              return (
                <option value={remarkItem} key={i}>{++i}</option>

              )
            })}
          </select>

          :
          <select
            key={`thead-${i}`}
            className="form-select"
            name={`${selectedValueKey}${i}`}
            id={`${selectedValueKey}${i}`}
            value={otherSelected ? otherSelected : item[selectedValueKey]}
            onChange={e => handleOnChangeRemark(item, selectedValueKey, forRemarkTextKey, e.target.value, requiredKey)}
          >
            <option value="">Select</option>
            {otherRemark.map((remarkItem, i) => {
              return (
                <option value={remarkItem} key={i}>{++i}</option>

              )
            })}
          </select>

        }

      </>
    );
  };

  //Remark on change
  const handleOnChangeRemark = (item, field, forRemarkTextKey, newValue, requiredKey = '') => {
    let indexId = item.id;
    let isRequired = false;


    if (newValue === '' && item[requiredKey] === true) {
      isRequired = true;
    }

    setItemData(prevItemData => {
      const updatedItemData = {
        ...prevItemData,
        [indexId]: {
          ...prevItemData[indexId],
          [field]: newValue,
          [requiredKey]: isRequired,

          [forRemarkTextKey]: ''
        }
      };
      return updatedItemData;
    });
  }


  // Function to handle the store chckbox checked data 
  const handleCheckboxChange = (event, index) => {
    if (event.target.checked) {
      setCheckedItems([...checkedItems, index]);
    } else {
      setCheckedItems(checkedItems.filter((item) => item !== index));
    }
  }




  // handle textBox On change Event 
  const handleOnChange = async (indexId, field, newValue,) => {

    if (!isNumeric(newValue) && field !== "blockName" && field !== 'rejectRemark') {
      toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
      toast.error(" Are you sure, 0 can be enterd?", messages.COLOR_RED);
      newValue = '0';
    }


    if (field === 'blockName') {
      if (monthName === '' || yearName === '') {
        toast.error(monthName === '' ? messages.MONTH_MSG : messages.YEAR_NAME_MSG, messages.COLOR_RED);
        newValue = '';
      } else {
        const foundObject = Object.values(itemData).find(item => item.blockName === newValue);
        if (foundObject) {
          toast.error(messages.MUNICIPAL_NAME, messages.COLOR_RED);
          newValue = '';
        }
      }
    }


    if (field === 'blockName' && newValue !== '') {
      let blockData = blockAllData.find(item => item.blockName === newValue)
      let wage_avg = '';
      let payload = {
        district_Code: districtCode,
        block_name: newValue,
        month_name: monthName,
        year_name: yearName,
        state: 1
      }

      try {
        showLoading(true);
        const response = await axios.post(`${API_URL}api/labourWages/lwsRuralWageRateForMenBlock`, payload, config);
        const { data, status } = response.data;

        // Check if response status is false
        if (!status || response.data.status === false) {
          showLoading(false);
          const errorMessage = response.data.message || 'An error occurred while processing your request.';
          toast.error(errorMessage, messages.COLOR_RED);
          return;
        }

        wage_avg = data.GroupCodes[0];

        setItemData(prevItemData => {
          const updatedItemData = {
            ...prevItemData,
            [indexId]: {
              ...prevItemData[indexId],
              [field]: newValue,
              "blockName": blockData.blockName,
              'carpenterTotalWages': wage_avg.carpenterTotalWages,
              'masonTotalWages': wage_avg.masonTotalWages,
              'tailorTotalWages': wage_avg.tailorTotalWages,
              'barberTotalWages': wage_avg.barberTotalWages,
              'spillerMachineWages': wage_avg.spillerMachineWages,
              'spillerCrusherWages': wage_avg.spillerCrusherWages,
              'bricksTotalWages': wage_avg.bricksTotalWages,
              'charwahaCowTotalWages': wage_avg.charwahaCowTotalWages,
              'charwahaBuffaloTotalWages': wage_avg.charwahaBuffaloTotalWages,
              'ploughingTotalWages': wage_avg.ploughingTotalWages,
              'sowingTotalWages': wage_avg.sowingTotalWages,
              'weedingTotalWages': wage_avg.weedingTotalWages,
              'harvestingTotalWages': wage_avg.harvestingTotalWages,
              'threshingTotalWages': wage_avg.threshingTotalWages,
              'otherTotalWages': wage_avg.otherTotalWages,

              "carpenterTotalWagesAvg": wage_avg.carpenterTotalWagesAvg,
              "masonTotalWagesAvg": wage_avg.masonTotalWagesAvg,
              "tailorTotalWagesAvg": wage_avg.tailorTotalWagesAvg,
              "barberTotalWagesAvg": wage_avg.barberTotalWagesAvg,
              "spillerCrusherWagesAvg": wage_avg.spillerCrusherWagesAvg,
              "spillerMachineWagesAvg": wage_avg.spillerMachineWagesAvg,
              "bricksAvg": wage_avg.bricksAvg,
              "cowTotalWagesAvg": wage_avg.cowTotalWagesAvg,
              "buffaloTotalWagesAvg": wage_avg.buffaloTotalWagesAvg,
              "ploughingTotalWagesAvg": wage_avg.ploughingTotalWagesAvg,
              "showingTotalWagesAvg": wage_avg.showingTotalWagesAvg,
              "weedingTotalWagesAvg": wage_avg.weedingTotalWagesAvg,
              "harvestingTotalWagesAvg": wage_avg.harvestingTotalWagesAvg,
              "threshingTotalWagesAvg": wage_avg.threshingTotalWagesAvg,
              "otherTotalWagesAvg": wage_avg.otherTotalWagesAvg,


            }
          };
          return updatedItemData;
        });
        showLoading(false);

      } catch (error) {
        showLoading(false);
        const errorMessage = error.response?.data?.message || error.message || 'An error occurred while processing your request.';
        toast.error(errorMessage, messages.COLOR_RED);
      }


    } else {

      setItemData(prevItemData => {
        const updatedItemData = {
          ...prevItemData,
          [indexId]: {
            ...prevItemData[indexId],
            [field]: newValue,
          }
        };
        return updatedItemData;
      });
    }

  }


  // handle textBox On Blur Event action
  const handleCheckVariation = (indexId, styleField, remarkRequiredField, newValue, average, variation) => {


    if (!isNumeric(newValue)) {
      toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
      toast.error(" Are you sure, 0 can be enterd?", messages.COLOR_RED);
      newValue = 0;
    }
    if (average === null || average === '') {
      average = 0
    }
    if (newValue === null || newValue === '' || newValue === 'NaN') {
      newValue = 0
    }

    let dynamicStylesForTextBox = {};
    let isRequiredRemark = false;

    if (newValue !== 0) {
      let dif = average * variation / 100;
      if (variation === 0 || dif === 0) {
        return;
      }
      if (newValue > (parseFloat(average) + dif) || newValue < (average - dif)) {
        toast.error(messages.VARIATION_MSG, messages.COLOR_RED);
        dynamicStylesForTextBox = {
          borderTop: '1px solid rgb(220, 223, 225)',
          borderRight: '1px solid rgb(220, 223, 225)',
          borderBottom: '1px solid rgb(220, 223, 225)',
          borderLeft: '6px solid red'
        };
        isRequiredRemark = true;


      } else {
        dynamicStylesForTextBox = {
          borderTop: '1px solid #dcdfe1',
          borderRight: '1px solid #dcdfe1',
          borderBottom: '1px solid #dcdfe1',
          borderLeft: '6px solid #dcdfe1'
        };
        isRequiredRemark = false;
      }
    }


    setItemData(prevItemData => ({
      ...prevItemData,
      [indexId]: {
        ...prevItemData[indexId],
        [styleField]: dynamicStylesForTextBox,
        [remarkRequiredField]: isRequiredRemark
      }
    }));

  };





  // handleReset Reset All form dara
  const resetForm = () => {
    resetMothAndYearAndDistrictField()
  }


  //handle Save the data
  const handleRuralMenWagesFormData = async (e, buttonType) => {


    if (!monthAndYearValidation()) {
      return true;
    }
    let clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel); //button click status flag
    const customItemCodes = [];
    // let check = 0;
    // let localbodyCodeCheck=0
    let statusFlag = '';
    // let isRejectStatus =false;
    let lastIsRequiredRemark = null;

    // Check reject remark validation before loop (only for first row)
    if (buttonType === "REJECT") {
      const firstRowRejectRemark = itemData[0]?.rejectRemark || '';
      if (!firstRowRejectRemark || firstRowRejectRemark.trim() === '') {
        toast.error(`Please Enter Reject Remarks`, messages.COLOR_RED);
        return false;
      }
    }

    for (let id in itemData) {

      if (itemData[id].blockName === '') {
        toast.error("Please Select Block Name", messages.COLOR_RED);
        return false;
      }

      if (itemData[id].blockName !== '') {

        let blockCode = itemData[id].blockCode;

        let blockName = itemData[id].blockName;
        let carpenterTotalWages = itemData[id].carpenterTotalWages;
        let masonTotalWages = itemData[id].masonTotalWages;
        let tailorTotalWages = itemData[id].tailorTotalWages;
        let barberTotalWages = itemData[id].barberTotalWages;
        let spillerMachineWages = itemData[id].spillerMachineWages;

        let spillerCrusherWages = itemData[id].spillerCrusherWages;
        let bricksTotalWages = itemData[id].bricksTotalWages;
        let charwahaCowTotalWages = itemData[id].charwahaCowTotalWages;

        let charwahaBuffaloTotalWages = itemData[id].charwahaBuffaloTotalWages;
        let ploughingTotalWages = itemData[id].ploughingTotalWages;
        let sowingTotalWages = itemData[id].sowingTotalWages;


        let weedingTotalWages = itemData[id].weedingTotalWages;
        let harvestingTotalWages = itemData[id].harvestingTotalWages;
        let threshingTotalWages = itemData[id].threshingTotalWages;
        let otherTotalWages = itemData[id].otherTotalWages;

        statusFlag = (itemData[id].statusFlag === '') ? clickButtonStatusFlag : itemData[id].statusFlag; //database Statusflag

        let remarkCarpenterTotalWages = handleRemarkTextForPost(itemData[id].remarkCarpenterTotalWagesSelectValue, itemData[id].remarkCarpenterTotalWages);
        let remarkMasonTotalWages = handleRemarkTextForPost(itemData[id].remarkMasonTotalWagesSelectValue, itemData[id].remarkMasonTotalWages)
        let remarkTailorTotalWages = handleRemarkTextForPost(itemData[id].remarkTailorTotalWagesSelectValue, itemData[id].remarkTailorTotalWages)
        let remarkBarberTotalWages = handleRemarkTextForPost(itemData[id].remarkBarberTotalWagesSelectValue, itemData[id].remarkBarberTotalWages)
        let remarkSpillerMachineWages = handleRemarkTextForPost(itemData[id].remarkSpillerMachineWagesSelectValue, itemData[id].remarkSpillerMachineWages)


        let remarkSpillerCrusherWages = handleRemarkTextForPost(itemData[id].remarkSpillerCrusherWagesSelectValue, itemData[id].remarkSpillerCrusherWages)
        let remarkBricks = handleRemarkTextForPost(itemData[id].remarkBricksSelectValue, itemData[id].remarkBricks)
        let remarkCowTotalWages = handleRemarkTextForPost(itemData[id].remarkCowTotalWagesSelectValue, itemData[id].remarkCowTotalWages)
        let remarkBuffaloTotalWages = handleRemarkTextForPost(itemData[id].remarkBuffaloTotalWagesSelectValue, itemData[id].remarkBuffaloTotalWages)
        let remarkPloughingTotalWages = handleRemarkTextForPost(itemData[id].remarkPloughingTotalWagesSelectValue, itemData[id].remarkPloughingTotalWages)


        let remarkShowingTotalWages = handleRemarkTextForPost(itemData[id].remarkShowingTotalWagesSelectValue, itemData[id].remarkShowingTotalWages)
        let remarkWeedingTotalWages = handleRemarkTextForPost(itemData[id].remarkWeedingTotalWagesSelectValue, itemData[id].remarkWeedingTotalWages)
        let remarkHarvestingTotalWages = handleRemarkTextForPost(itemData[id].remarkHarvestingTotalWagesSelectValue, itemData[id].remarkHarvestingTotalWages)
        let remarkThreshingTotalWages = handleRemarkTextForPost(itemData[id].remarkThreshingTotalWagesSelectValue, itemData[id].remarkThreshingTotalWages)
        let remarkOtherTotalWages = handleRemarkTextForPost(itemData[id].remarkOtherTotalWagesSelectValue, itemData[id].remarkOtherTotalWages)

        // Get rejectRemark from first row only (index 0) for all rows
        let rejectRemark = itemData[0]?.rejectRemark || '';


        if (buttonType !== "REJECT") {
          // Remark Vaalidation
          for (let i = 0; i < ruralMenPropertyNames.length; i++) {
            const propertyName = ruralMenPropertyNames[i];

            if (propertyName.endsWith('IsRequiredRemark')) {
              console.log(itemData[id][propertyName])
              if (itemData[id][propertyName] === true) {
                toast.error(`Please select the Remark`, messages.COLOR_RED);
                return false;
              }

            }
          }
        }

        if (buttonType === "SUBMIT") {
          statusFlag = clickButtonStatusFlag;
        }
        if (buttonType === "ACCEPT" || buttonType === "SAVE") { //Accept Button click
          statusFlag = clickButtonStatusFlag;
        }

        if (buttonType === "REJECT") {
          statusFlag = clickButtonStatusFlag;
        }

        const customObject = {
          blockCode: blockCode,
          blockName: blockName,
          carpenterTotalWages: carpenterTotalWages,
          masonTotalWages: masonTotalWages,
          tailorTotalWages: tailorTotalWages,
          barberTotalWages: barberTotalWages,
          spillerMachineWages: spillerMachineWages,
          spillerCrusherWages: spillerCrusherWages,
          bricksTotalWages: bricksTotalWages,
          charwahaCowTotalWages: charwahaCowTotalWages,
          charwahaBuffaloTotalWages: charwahaBuffaloTotalWages,
          ploughingTotalWages: ploughingTotalWages,
          sowingTotalWages: sowingTotalWages,
          weedingTotalWages: weedingTotalWages,
          harvestingTotalWages: harvestingTotalWages,
          threshingTotalWages: threshingTotalWages,
          otherTotalWages: otherTotalWages,
          statusFlag: statusFlag,

          remarkCarpenterTotalWages: remarkCarpenterTotalWages,
          remarkMasonTotalWages: remarkMasonTotalWages,
          remarkTailorTotalWages: remarkTailorTotalWages,
          remarkBarberTotalWages: remarkBarberTotalWages,
          remarkSpillerMachineWages: remarkSpillerMachineWages,
          remarkSpillerCrusherWages: remarkSpillerCrusherWages,
          remarkBricks: remarkBricks,
          remarkCowTotalWages: remarkCowTotalWages,
          remarkBuffaloTotalWages: remarkBuffaloTotalWages,
          remarkPloughingTotalWages: remarkPloughingTotalWages,
          remarkShowingTotalWages: remarkShowingTotalWages,
          remarkWeedingTotalWages: remarkWeedingTotalWages,
          remarkHarvestingTotalWages: remarkHarvestingTotalWages,
          remarkThreshingTotalWages: remarkThreshingTotalWages,
          remarkOtherTotalWages: remarkOtherTotalWages,
          rejectRemark: rejectRemark

        }


        customItemCodes.push(customObject);
      }

    }

    let postData = {
      itemCodes: customItemCodes,
      payload: {
        month_name: monthName,
        year_name: yearName,
        district_code: districtCode,
        buttonType: buttonType,
        statusButtonFlag: clickButtonStatusFlag
      }
    }
    // return false;
    showLoading(true)
    try {

      const response = await axios.post(`${API_URL}api/labourWages/getRuralLabourWagesRatesnputFormWithDataSaveToDB`, postData, config);
      if (response.data.status) {
        toast.success(response.data.message, messages.COLOR_RED);
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
      showLoading(false);
      resetForm()

    }
  }


  {/* Show remark Text for the post Data*/ }
  const handleRemarkTextForPost = (remarkSelectedValue, remarkText) => {

    {/* Show remark Text */ }
    let remarkTextForPost = 'NQ';
    let text = '';

    if (remarkSelectedValue) {
      text = remarkSelectedValue;
    } else {
      text = remarkText;
    }

    if (userInfoObject.userLevel === 'HEAD QUARTER' &&
      headQuarterRemark.includes(text)) {
      remarkTextForPost = text

    }

    if (userInfoObject.userLevel !== 'HEAD QUARTER' &&
      otherRemark.includes(text)) {
      remarkTextForPost = text

    }
    return remarkTextForPost;
  }

  return (
    <div className="card-body">
      {/* <ToastContainer/> */}
      <div className="table-responsive">
        <table cellPadding="6" className="table table-bordered text-nowrap text-center">
          <thead>
            <tr>
              <th></th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Serial_No : priceTitle.en.Serial_No}</th>
              <th colSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Business_Criteria : priceTitle.en.Business_Criteria}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.CARPENTER : priceTitle.en.CARPENTER}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.MASON : priceTitle.en.MASON}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Tailor : priceTitle.en.Tailor}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Barber : priceTitle.en.Barber}</th>
              <th colSpan={2}>{storedLanguage === 'hi' ? priceTitle.hi.Spiller : priceTitle.en.Spiller}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Bricking : priceTitle.en.Bricking}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Charwaha_Cow : priceTitle.en.Charwaha_Cow}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Charwaha_Buffalo : priceTitle.en.Charwaha_Buffalo}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Field_Ploughing : priceTitle.en.Field_Ploughing}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Sowing : priceTitle.en.Sowing}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Weeding : priceTitle.en.Weeding}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Harvesting : priceTitle.en.Harvesting}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Threshing : priceTitle.en.Threshing}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Other : priceTitle.en.Other}</th>
            </tr>
            <tr>
              <th></th>
              <th>0</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Block_Name : priceTitle.en.Block_Name}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Village_Name : priceTitle.en.Village_Name}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
              <th rowSpan={2}>{storedLanguage === 'hi' ? priceTitle.hi.Spiller_Machine_Wages : priceTitle.en.Spiller_Machine_Wages}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Spiller_Crusher_Wages : priceTitle.en.Spiller_Crusher_Wages}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
            </tr>
          </thead>
          <tbody>
            {

              Object.values(itemData).map((item, i) => {
                srNo = i
                return (
                  <tr key={i}>
                    <td>
                      {i !== 0 &&
                        <input
                          type="checkbox"
                          id={`checkbox-${i}-id`}
                          checked={checkedItems.includes(i)}
                          onChange={(event) => handleCheckboxChange(event, i)}
                        />
                      }
                    </td>

                    <td>{++srNo}</td>
                    <td>
                      <select
                        className="form-select"
                        value={`${itemData[item.id]?.blockName}` || ''}
                        onChange={e => handleOnChange(item.id, 'blockName', e.target.value)}
                        disabled={(Object.values(itemData).length === 1 && districtCode === '') ||
                          (isSubmitBtnDisable || isAcceptBtnDisable || isRejectBtnDisable || isSaveBtnDisable)}
                      >
                        <option>Select</option>
                        {blockAllData.map((nm, index) => (
                          <option
                            key={index}
                            value={`${nm.blockName}`}
                          //  value={`${nm.blockCode}-${nm.blockName}`}
                          >
                            {nm.blockName}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>

                      <select className="form-select" disabled>
                        <option>Select</option>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control mb-1"
                        name={`carpenterTotalWages${i}`}
                        id={`carpenterTotalWages${i}`}
                        style={itemData[item.id]?.carpenterTotalWagesStyle || {}}
                        value={itemData[item.id]?.carpenterTotalWages || ""}
                        onChange={e => handleOnChange(item.id, 'carpenterTotalWages', e.target.value)}
                        onBlur={e => handleCheckVariation(item.id, 'carpenterTotalWagesStyle', 'carpenterTotalWagesIsRequiredRemark', parseFloat(e.target.value), item.carpenterTotalWagesAvg, 10)}
                        maxLength="3"
                        disabled={!item.blockName}
                      />
                      {remarkDropDown(item, i, 'remarkCarpenterTotalWagesSelectValue', 'remarkCarpenterTotalWages', 'carpenterTotalWagesIsRequiredRemark')}
                    </td>

                    <td>
                      <input
                        type="text"
                        className="form-control mb-1"
                        name={`masonTotalWages${i}`}
                        id={`masonTotalWages${i}`}
                        style={itemData[item.id]?.masonTotalWagesStyle || {}}
                        value={itemData[item.id]?.masonTotalWages || ""}
                        onChange={e => handleOnChange(item.id, 'masonTotalWages', e.target.value)}
                        onBlur={e => handleCheckVariation(item.id, 'masonTotalWagesStyle', 'masonTotalWagesIsRequiredRemark', parseFloat(e.target.value), item.masonTotalWagesAvg, 10)}
                        maxLength="3"
                        disabled={!item.blockName}
                      />
                      {remarkDropDown(item, i, 'remarkMasonTotalWagesSelectValue', 'remarkMasonTotalWages', 'masonTotalWagesIsRequiredRemark')}
                    </td>

                    <td>
                      <input
                        type="text"
                        className="form-control mb-1"
                        name={`tailorTotalWages${i}`}
                        id={`tailorTotalWages${i}`}
                        style={itemData[item.id]?.tailorTotalWagesStyle || {}}
                        value={itemData[item.id]?.tailorTotalWages || ""}
                        onChange={e => handleOnChange(item.id, 'tailorTotalWages', e.target.value)}
                        onBlur={e => handleCheckVariation(item.id, 'tailorTotalWagesStyle', 'tailorTotalWagesIsRequiredRemark', parseFloat(e.target.value), item.tailorTotalWagesAvg, 10)}
                        maxLength="3"
                        disabled={!item.blockName}
                      />
                      {remarkDropDown(item, i, 'remarkTailorTotalWagesSelectValue', 'remarkTailorTotalWages', 'tailorTotalWagesIsRequiredRemark')}
                    </td>

                    <td>
                      <input
                        type="text"
                        className="form-control mb-1"
                        name={`barberTotalWages${i}`}
                        id={`barberTotalWages${i}`}
                        style={itemData[item.id]?.barberTotalWagesStyle || {}}
                        value={itemData[item.id]?.barberTotalWages || ""}
                        onChange={e => handleOnChange(item.id, 'barberTotalWages', e.target.value)}
                        onBlur={e => handleCheckVariation(item.id, 'barberTotalWagesStyle', 'barberTotalWagesIsRequiredRemark', parseFloat(e.target.value), item.barberTotalWagesAvg, 10)}
                        maxLength="3"
                        disabled={!item.blockName}
                      />
                      {remarkDropDown(item, i, 'remarkBarberTotalWagesSelectValue', 'remarkBarberTotalWages', 'barberTotalWagesIsRequiredRemark')}
                    </td>

                    <td>
                      <input
                        type="text"
                        className="form-control mb-1"
                        name={`spillerMachineWages${i}`}
                        id={`spillerMachineWages${i}`}
                        style={itemData[item.id]?.spillerMachineWagesStyle || {}}
                        value={itemData[item.id]?.spillerMachineWages || ""}
                        onChange={e => handleOnChange(item.id, 'spillerMachineWages', e.target.value)}
                        onBlur={e => handleCheckVariation(item.id, 'spillerMachineWagesStyle', 'spillerMachineWagesIsRequiredRemark', parseFloat(e.target.value), item.spillerMachineWagesAvg, 10)}
                        maxLength="3"
                        disabled={!item.blockName}
                      />
                      {remarkDropDown(item, i, 'remarkSpillerMachineWagesSelectValue', 'remarkSpillerMachineWages', 'spillerMachineWagesIsRequiredRemark')}
                    </td>

                    <td>

                      <input
                        type="text"
                        className="form-control mb-1"
                        name={`spillerCrusherWages${i}`}
                        id={`spillerCrusherWages${i}`}
                        style={itemData[item.id]?.spillerCrusherWagesStyle || {}}
                        value={itemData[item.id]?.spillerCrusherWages || ""}
                        onChange={e => handleOnChange(item.id, 'spillerCrusherWages', e.target.value)}
                        onBlur={e => handleCheckVariation(item.id, 'spillerCrusherWagesStyle', 'spillerCrusherWagesIsRequiredRemark', parseFloat(e.target.value), item.spillerCrusherWagesAvg, 10)}
                        maxLength="3"
                        disabled={!item.blockName}
                      />
                      {remarkDropDown(item, i, 'remarkSpillerCrusherWagesSelectValue', 'remarkSpillerCrusherWages', 'spillerCrusherWagesIsRequiredRemark')}
                    </td>

                    <td>

                      <input
                        type="text"
                        className="form-control mb-1"
                        name={`bricksTotalWages${i}`}
                        id={`bricksTotalWages${i}`}
                        style={itemData[item.id]?.bricksTotalWagesStyle || {}}
                        value={itemData[item.id]?.bricksTotalWages || ""}
                        onChange={e => handleOnChange(item.id, 'bricksTotalWages', e.target.value)}
                        onBlur={e => handleCheckVariation(item.id, 'bricksTotalWagesStyle', 'bricksTotalWagesIsRequiredRemark', parseFloat(e.target.value), item.bricksAvg, 10)}
                        maxLength="4"
                        disabled={!item.blockName}
                      />
                      {remarkDropDown(item, i, 'remarkBricksSelectValue', 'remarkBricks', 'bricksTotalWagesIsRequiredRemark')}
                    </td>

                    <td>
                      <input
                        type="text"
                        className="form-control mb-1"
                        name={`charwahaCowTotalWages${i}`}
                        id={`charwahaCowTotalWages${i}`}
                        style={itemData[item.id]?.charwahaCowTotalWagesStyle || {}}
                        value={itemData[item.id]?.charwahaCowTotalWages || ""}
                        onChange={e => handleOnChange(item.id, 'charwahaCowTotalWages', e.target.value)}
                        onBlur={e => handleCheckVariation(item.id, 'charwahaCowTotalWagesStyle', 'charwahaCowTotalWagesIsRequiredRemark', parseFloat(e.target.value), item.cowTotalWagesAvg, 10)}
                        maxLength="3"
                        disabled={!item.blockName}
                      />
                      {remarkDropDown(item, i, 'remarkCowTotalWagesSelectValue', 'remarkCowTotalWages', 'charwahaCowTotalWagesIsRequiredRemark')}
                    </td>

                    <td>

                      <input
                        type="text"
                        className="form-control mb-1"
                        name={`charwahaBuffaloTotalWages${i}`}
                        id={`charwahaBuffaloTotalWages${i}`}
                        style={itemData[item.id]?.charwahaBuffaloTotalWagesStyle || {}}
                        value={itemData[item.id]?.charwahaBuffaloTotalWages || ""}
                        onChange={e => handleOnChange(item.id, 'charwahaBuffaloTotalWages', e.target.value)}
                        onBlur={e => handleCheckVariation(item.id, 'charwahaBuffaloTotalWagesStyle', 'charwahaBuffaloTotalWagesIsRequiredRemark', parseFloat(e.target.value), item.buffaloTotalWagesAvg, 10)}
                        maxLength="3"
                        disabled={!item.blockName}
                      />
                      {remarkDropDown(item, i, 'remarkBuffaloTotalWagesSelectValue', 'remarkBuffaloTotalWages', 'charwahaBuffaloTotalWagesIsRequiredRemark')}
                    </td>

                    <td>

                      <input
                        type="text"
                        className="form-control mb-1"
                        name={`ploughingTotalWages${i}`}
                        id={`ploughingTotalWages${i}`}
                        style={itemData[item.id]?.ploughingTotalWagesStyle || {}}
                        value={itemData[item.id]?.ploughingTotalWages || ""}
                        onChange={e => handleOnChange(item.id, 'ploughingTotalWages', e.target.value)}
                        onBlur={e => handleCheckVariation(item.id, 'ploughingTotalWagesStyle', 'ploughingTotalWagesIsRequiredRemark', parseFloat(e.target.value), item.ploughingTotalWagesAvg, 10)}
                        maxLength="3"
                        disabled={!item.blockName}
                      />
                      {remarkDropDown(item, i, 'remarkPloughingTotalWagesSelectValue', 'remarkPloughingTotalWages', 'ploughingTotalWagesIsRequiredRemark')}
                    </td>

                    <td>
                      <input
                        type="text"
                        className="form-control mb-1"
                        name={`sowingTotalWages${i}`}
                        id={`sowingTotalWages${i}`}
                        style={itemData[item.id]?.sowingTotalWagesStyle || {}}
                        value={itemData[item.id]?.sowingTotalWages || ""}
                        onChange={e => handleOnChange(item.id, 'sowingTotalWages', e.target.value)}
                        onBlur={e => handleCheckVariation(item.id, 'sowingTotalWagesStyle', 'sowingTotalWagesIsRequiredRemark', parseFloat(e.target.value), item.ploughingTotalWagesAvg, 10)}
                        maxLength="3"
                        disabled={!item.blockName}
                      />
                      {remarkDropDown(item, i, 'remarkShowingTotalWagesSelectValue', 'remarkShowingTotalWages', 'sowingTotalWagesIsRequiredRemark')}
                    </td>

                    <td>

                      <input
                        type="text"
                        className="form-control mb-1"
                        name={`weedingTotalWages${i}`}
                        id={`weedingTotalWages${i}`}
                        style={itemData[item.id]?.weedingTotalWagesStyle || {}}
                        value={itemData[item.id]?.weedingTotalWages || ""}
                        onChange={e => handleOnChange(item.id, 'weedingTotalWages', e.target.value)}
                        onBlur={e => handleCheckVariation(item.id, 'weedingTotalWagesStyle', 'weedingTotalWagesIsRequiredRemark', parseFloat(e.target.value), item.weedingTotalWagesAvg, 10)}
                        maxLength="3"
                        disabled={!item.blockName}
                      />
                      {remarkDropDown(item, i, 'remarkWeedingTotalWagesSelectValue', 'remarkWeedingTotalWages', 'weedingTotalWagesIsRequiredRemark')}
                    </td>

                    <td>

                      <input
                        type="text"
                        className="form-control mb-1"
                        name={`harvestingTotalWages${i}`}
                        id={`harvestingTotalWages${i}`}
                        style={itemData[item.id]?.harvestingTotalWagesStyle || {}}
                        value={itemData[item.id]?.harvestingTotalWages || ""}
                        onChange={e => handleOnChange(item.id, 'harvestingTotalWages', e.target.value)}
                        onBlur={e => handleCheckVariation(item.id, 'harvestingTotalWagesStyle', 'harvestingTotalWagesIsRequiredRemark', parseFloat(e.target.value), item.harvestingTotalWagesAvg, 10)}
                        maxLength="3"
                        disabled={!item.blockName}
                      />
                      {remarkDropDown(item, i, 'remarkHarvestingTotalWagesSelectValue', 'remarkHarvestingTotalWages', 'harvestingTotalWagesIsRequiredRemark')}
                    </td>

                    <td>
                      <input
                        type="text"
                        className="form-control mb-1"
                        name={`threshingTotalWages${i}`}
                        id={`threshingTotalWages${i}`}
                        style={itemData[item.id]?.threshingTotalWagesStyle || {}}
                        value={itemData[item.id]?.threshingTotalWages || ""}
                        onChange={e => handleOnChange(item.id, 'threshingTotalWages', e.target.value)}
                        onBlur={e => handleCheckVariation(item.id, 'threshingTotalWagesStyle', 'threshingTotalWagesIsRequiredRemark', parseFloat(e.target.value), item.threshingTotalWagesAvg, 10)}
                        maxLength="3"
                        disabled={!item.blockName}
                      />
                      {remarkDropDown(item, i, 'remarkThreshingTotalWagesSelectValue', 'remarkThreshingTotalWages', 'threshingTotalWagesIsRequiredRemark')}
                    </td>

                    <td>

                      <input
                        type="text"
                        className="form-control mb-1"
                        name={`otherTotalWages${i}`}
                        id={`otherTotalWages${i}`}
                        style={itemData[item.id]?.otherTotalWagesStyle || {}}
                        value={itemData[item.id]?.otherTotalWages || ""}
                        onChange={e => handleOnChange(item.id, 'otherTotalWages', e.target.value)}
                        onBlur={e => handleCheckVariation(item.id, 'otherTotalWagesStyle', 'otherTotalWagesIsRequiredRemark', parseFloat(e.target.value), item.otherTotalWagesAvg, 10)}
                        maxLength="3"
                        disabled={!item.blockName}
                      />
                      {remarkDropDown(item, i, 'remarkOtherTotalWagesSelectValue', 'remarkOtherTotalWages', 'otherTotalWagesIsRequiredRemark')}
                    </td>
                  </tr>
                );
              })
            }
            {averageData && (
              <tr>
                <td></td>
                <td></td>
                <td colSpan={2}>Average</td>

                <>
                  <td>{averageData.avgcarpenterTotalWages ? averageData.avgcarpenterTotalWages.toFixed(2) : 0}</td>
                  <td>{averageData.avgmasonTotalWages ? averageData.avgmasonTotalWages.toFixed(2) : 0}</td>
                  <td>{averageData.avgtailorTotalWages ? averageData.avgtailorTotalWages.toFixed(2) : 0}</td>
                  <td>{averageData.avgbarberTotalWages ? averageData.avgbarberTotalWages.toFixed(2) : 0}</td>

                  <td>{averageData.avgspillerMachineWages ? averageData.avgspillerMachineWages.toFixed(2) : 0}</td>
                  <td>{averageData.avgspillerCrusherWages ? averageData.avgspillerCrusherWages.toFixed(2) : 0}</td>
                  <td>{averageData.avgbricksTotalWages ? averageData.avgbricksTotalWages.toFixed(2) : 0}</td>
                  <td>{averageData.avgcharwahaCowTotalWages ? averageData.avgcharwahaCowTotalWages.toFixed(2) : 0}</td>

                  <td>{averageData.avgcharwahaBuffaloTotalWages ? averageData.avgcharwahaBuffaloTotalWages.toFixed(2) : 0}</td>
                  <td>{averageData.avgploughingTotalWages ? averageData.avgploughingTotalWages.toFixed(2) : 0}</td>
                  <td>{averageData.avgsowingTotalWages ? averageData.avgsowingTotalWages.toFixed(2) : 0}</td>
                  <td>{averageData.avgweedingTotalWages ? averageData.avgweedingTotalWages.toFixed(2) : 0}</td>

                  <td>{averageData.avgharvestingTotalWages ? averageData.avgharvestingTotalWages.toFixed(2) : 0}</td>
                  <td>{averageData.avgthreshingTotalWages ? averageData.avgthreshingTotalWages.toFixed(2) : 0}</td>
                  <td>{averageData.avgotherTotalWages ? averageData.avgotherTotalWages.toFixed(2) : 0}</td>
                </>

              </tr>
            )}

            <tr>
              <td colSpan="2" className="fw-bold">Remark</td>
              <td colSpan="16">
                <textarea
                  className="form-control h-auto"
                  rows="3"
                  onChange={e => handleOnChange(0, 'rejectRemark', e.target.value)}
                  value={itemData[0]?.rejectRemark}
                >
                </textarea>
              </td>
            </tr>
          </tbody>
        </table>


      </div>

      <div className="row">
        <div className="col-12 text-center pt-3">
          <button
            type="button"
            onClick={addRow}
            disabled={(Object.values(itemData).length === blockAllData.length) ||
              (isSubmitBtnDisable || isAcceptBtnDisable || isRejectBtnDisable || isSaveBtnDisable)}
            className="btn btn_orange mx-1"
          >
            Add Row
          </button>

          <button
            type="button"
            onClick={deleteRows}
            disabled={isSubmitBtnDisable || isAcceptBtnDisable || isRejectBtnDisable || isSaveBtnDisable}
            className="btn btn_orange mx-1"
          >
            Delete Row
          </button>

          <button
            type="button"
            className={`btn btn_orange mx-1 ${isSaveBtnDisable ? 'disabled' : ''}`}
            onClick={(e) => handleRuralMenWagesFormData(e, 'SAVE')}
          >
            Save
          </button>


          {
            (userInfoObject.userLevel === 'DISTRICT LEVEL' ||
              userInfoObject.userLevel === 'DIVISION LEVEL') &&

            <button
              type="submit"
              className={`btn btn_orange mx-1 ${isSubmitBtnDisable ? 'disabled' : ''}`}
              onClick={(e) => handleRuralMenWagesFormData(e, 'SUBMIT')}
            >
              Submit
            </button>
          }

          {(userInfoObject.userLevel === 'HEAD QUARTER') &&
            <>
              <button
                type="submit"
                className={`btn btn_orange mx-1 ${isAcceptBtnDisable ? 'disabled' : ''}`}
                onClick={(e) => handleRuralMenWagesFormData(e, 'ACCEPT')}
              >
                Accept
              </button>

              <button
                type="submit"
                className={`btn btn_orange mx-1 ${isRejectBtnDisable ? 'disabled' : ''}`}
                onClick={(e) => handleRuralMenWagesFormData(e, 'REJECT')}
              >
                Reject
              </button>

            </>
          }


          <button
            type="reset"
            className="btn btn_orange mx-1"
            onClick={resetForm}
          >
            Reset
          </button>

          <button
            type="button"
            className="btn btn_orange mx-1"
            onClick={(e) => (navigate("/dashboard"))}
          >
            Cancel
          </button>
        </div>
      </div>

    </div>
  )
}

export default RuralMenWagesData